import { object } from "yup";

import {
  dbIdValidationSchema,
  draftValidationSchema,
  titleValidationSchema,
  urlValidationSchema,
} from "@dzambalaorg/yup-rules";
import { bigNumberValidationSchema } from "@dzambalaorg/yup-rules-eth";
import { templateAssetValidationSchema } from "@dzambalaorg/mui-inputs-asset";

export const collectionsTemplateValidationSchema = object().shape({
  title: titleValidationSchema,
  description: draftValidationSchema,
  price: templateAssetValidationSchema,
  amount: bigNumberValidationSchema,
  contractId: dbIdValidationSchema,
  imageUrl: urlValidationSchema,
});
